export const scrollToTop = () => {
    // Get the height of the fixed header
    const headerHeight = document.querySelector('header')?.offsetHeight ?? 0;
    // Calculate the scroll position
    const appElement = document.querySelector('.form-app');
    if (appElement) {
        const scrollPosition = appElement.getBoundingClientRect().top + window.scrollY - headerHeight;
        // Scroll to the calculated position
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    }
}